import { Stack } from '@asgard/ui-library';
import Page from 'components/layout/Page';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { createGlobalStyle } from 'styled-components';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { CompaniesPageProps } from './FreelanceCompaniesPage.types';
import { Hero } from './hero/Hero';

import dynamic from 'next/dynamic';

const Form = dynamic(() => import('./form/Form'), {
  ssr: false
});

const Features = dynamic(() => import('./features/Features'), {
  ssr: false
});

export const FreelanceCompaniesPage: React.FC<CompaniesPageProps> = ({
  bannerText
}) => {
  const { t } = useI18n('freelance-companies');

  const PageGlobalStyles = createGlobalStyle`
      #freshworks-container iframe {
        bottom: 90px !important;
      }
    `;

  return (
    <>
      <PageGlobalStyles />
      <HeadMetadata
        title={t('freelance-companies.page_title')}
        desc={t('freelance-companies.page_description')}
        url={APP_URLS.freelanceCompanies}
        imgUrl={`${getPublicPath(
          '/images/cards/card_freelance_companies.png'
        )}`}
        indexable={true}
      />
      <Page hasScrollTop pageVariant="midnight_light" bannerText={bannerText}>
        <Stack direction="column" gap="5xl">
          <Hero />
          <Features />
          <Form />
        </Stack>
      </Page>
    </>
  );
};
